<template>
  <main class="v-view-primary">
    <OrganismTheHeader/>
    <section class="v-edition-section">
      <OrganismEditionSectionNavigation/>
      <OrganismEditionSectionContent/>
    </section>
  </main>
</template>

<script>
export default {
  name: 'EditionSection',

  components: {
    OrganismEditionSectionNavigation: () => import('@/components/organisms/OrganismEditionSectionNavigation'),
    OrganismEditionSectionContent: () => import('@/components/organisms/OrganismEditionSectionContent')
  }
}
</script>
